import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { defineMessages, useIntl } from "react-intl";
import { IconChevronLeft, IconShoppingCartCancel } from "@tabler/icons-react";
import { useLocaleNavigate } from "@ct-react/locale";
import { actions } from "../../i18n/sharable-defs";
import { Wrapper } from "../../components/layout/wrapper";
import Button from "../../components/common/button";
import SuccessSvg from "../../assets/componable-svgs/succeeded-payment.svg";
import "./callback.scss";

const transDefs = defineMessages({
  success: { id: "cart.callback.success-title", defaultMessage: "Paiement réussi" },
  successText: { id: "cart.callback.success-text", defaultMessage: "Merci pour votre réservation. L'agence se fera un plaisir de vous recevoir." },
  failure: { id: "cart.callback.failure-title", defaultMessage: "Paiement annulé" },
  failureText: { id: "cart.callback.failure-text", defaultMessage: "Vous avez annulé le processus de paiement. Votre réservation est restée en attente auprès de l'agence." }
});

const CANCEL_PAYMENT_GQL_MUT = gql`
  mutation CancelPayment($sessionId: String!) {
    cartCanceledPayment(sessionId: $sessionId)
  }
`;

type Props = { succeeded: boolean };

const CallbackPage = ({ succeeded }: Props) => {

  const intl = useIntl();
  const navigate = useLocaleNavigate();
  const [ searchParams ] = useSearchParams();
  const [ cancellation ] = useMutation(CANCEL_PAYMENT_GQL_MUT);

  useEffect(() => {
    (!succeeded && searchParams.has("session_id")) && cancellation({
      variables: { sessionId: searchParams.get("session_id") },
    }).then();
  }, []);

  return (
    <Wrapper.Centered className="checkout-callback">
      {(!succeeded || !searchParams.has("no-payment")) &&
        <h2>
          {intl.formatMessage(succeeded ? transDefs.success : transDefs.failure)}
        </h2>
      }
      {succeeded
        ? <SuccessSvg className="success-svg" />
        : <IconShoppingCartCancel className="e-icon" />
      }
      <p>
        {intl.formatMessage(succeeded ? transDefs.successText : transDefs.failureText)}
      </p>
      <Button className="outline bold with-icon"
              onClick={() => navigate("/")}>
        <IconChevronLeft />
        {intl.formatMessage(actions.backHome)}
      </Button>
    </Wrapper.Centered>);

};

export default CallbackPage;
